import Vue from 'vue'
import AppMain from './components/app-main'
import router from './router'

Vue.config.productionTip = false

import config from '@/config/index.js'

/* eslint-disable no-new */
new Vue({
/* eslint-enable */
    el: '#app',

    router,

    components: { AppMain },

    template: '<app-main/>',

    watch:
    {
        $route(value, oldValue)
        {
            this.$previousRoute = oldValue
        }
    },

    created()
    {
        this.firstPage = true
        this.config = config
    },

    methods:
    {
        isFirstPage()
        {
            if(this.firstPage)
            {
                this.firstPage = false
                return true
            }

            return false
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js